var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{ref:"audio",attrs:{"controls":"controls"}},[_c('source',{attrs:{"src":_vm.src,"type":"audio/mpeg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }